// The EasySell cash-on-delivery form, on every Shopify page (store pages, product pages and the order page).
// 1. EasySell writes its colours inline with !important (white panel, black text), which no stylesheet can beat.
//    Strip only those colour properties as the app draws it, so shop.css can dress it per store.
// 2. "Use my current location" under the address: the phone's location fills the address with the place's name and a
//    Google Maps link (so the driver can open it), and picks the region. Place names from OpenStreetMap (Nominatim).
(function () {
  const PROPS = ['color', 'background', 'background-color', 'background-image', 'border-color', 'fill'];
  function clean(root) {
    if (!root || !root.querySelectorAll) return;
    const els = [root].concat(Array.from(root.querySelectorAll('[style]')));
    els.forEach(function (el) {
      if (!el.style || !el.getAttribute || !el.getAttribute('style')) return;
      PROPS.forEach(function (p) { if (el.style.getPropertyValue(p)) el.style.removeProperty(p); });
    });
  }

  const AR = function () { return document.documentElement.lang === 'ar'; };
  const T = {
    use: ['Use my current location', 'استخدم موقعي الحالي'],
    busy: ['Finding your location…', 'جارٍ تحديد موقعك…'],
    done: ['Location added', 'تمت إضافة الموقع'],
    again: ['Update', 'تحديث'],
    denied: ['Location is off. Allow it in your browser, or type the address.', 'الموقع غير مفعّل. فعّله في المتصفح أو اكتب العنوان.'],
    fail: ['Could not find your location. Please type the address.', 'تعذّر تحديد موقعك. اكتب العنوان من فضلك.'],
    open: ['Open map', 'افتح الخريطة']
  };
  const tx = function (k) { return T[k][AR() ? 1 : 0]; };
  const PIN = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/><circle cx="12" cy="12" r="7.5"/></svg>';

  // Lebanon's governorates as OpenStreetMap names them -> the form's region codes (Keserwan-Jbeil was part of Mount Lebanon)
  const REGION = [[/beirut|بيروت/i, 'LB_BA'], [/akkar|عكار/i, 'LB_AK'], [/baalbe|hermel|بعلبك|الهرمل/i, 'LB_BH'],
    [/beqaa|bekaa|biqa|البقاع/i, 'LB_BI'], [/nabat|النبطية/i, 'LB_NA'], [/keserw|jbeil|byblos|mount|جبل لبنان|كسروان/i, 'LB_JL'],
    [/north|الشمال/i, 'LB_AS'], [/south|الجنوب/i, 'LB_JA']];

  // EasySell is a Vue app: set the value the way typing would, so the form's own state sees it
  function setField(el, value) {
    const proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function placeName(a, d) {
    const road = a.road || a.pedestrian || a.neighbourhood || a.quarter || '';
    const area = a.suburb || a.village || a.town || a.city_district || a.city || a.municipality || '';
    const district = a.county || a.state_district || '';
    const parts = [a.house_number && road ? road + ' ' + a.house_number : road, area, district].filter(function (x, i, arr) { return x && arr.indexOf(x) === i; });
    return parts.length ? parts.join(', ') : (d.display_name || '').split(',').slice(0, 3).join(',');
  }

  function locate(box) {
    const form = box.closest('form') || document;
    const addr = form.querySelector('#es-address'), region = form.querySelector('#es-city');
    const btn = box.querySelector('.es-loc__btn'), note = box.querySelector('.es-loc__note');
    const say = function (state, html) { box.dataset.state = state; note.innerHTML = html || ''; };
    if (!navigator.geolocation) { say('error', tx('fail')); return; }
    btn.disabled = true; btn.querySelector('span').textContent = tx('busy'); say('busy');
    navigator.geolocation.getCurrentPosition(function (pos) {
      const lat = pos.coords.latitude.toFixed(6), lon = pos.coords.longitude.toFixed(6);
      const map = 'https://maps.google.com/?q=' + lat + ',' + lon;
      const finish = function (name, state) {
        if (addr) setField(addr, (name ? name + ' - ' : '') + map);
        if (region && state) {
          const hit = REGION.find(function (r) { return r[0].test(state); });
          if (hit && region.querySelector('option[value="' + hit[1] + '"]')) setField(region, hit[1]);
        }
        btn.disabled = false; btn.querySelector('span').textContent = tx('again');
        say('done', '✓ ' + tx('done') + (name ? ': ' + name.replace(/[<>&]/g, '') : '') + ' · <a href="' + map + '" target="_blank" rel="noopener">' + tx('open') + '</a>');
      };
      fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1&accept-language=' + (AR() ? 'ar,en' : 'en') + '&lat=' + lat + '&lon=' + lon)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) { const a = d.address || {}; finish(placeName(a, d), (a.state || '') + ' ' + (a.county || '') + ' ' + (a.city || '')); })
        .catch(function () { finish('', ''); });   // no place name: the map link alone still finds the house
    }, function (err) {
      btn.disabled = false; btn.querySelector('span').textContent = tx('use');
      say('error', tx(err && err.code === 1 ? 'denied' : 'fail'));
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 });
  }

  function addLocate(modal) {
    const addr = modal.querySelector('#es-address');
    if (!addr) return;
    const group = addr.closest('.es-address-group') || addr.parentNode;
    if (group.querySelector('.es-loc')) return;
    const box = document.createElement('div');
    box.className = 'es-loc';
    box.innerHTML = '<button type="button" class="es-loc__btn">' + PIN + '<span>' + tx('use') + '</span></button><p class="es-loc__note" aria-live="polite"></p>';
    box.querySelector('button').addEventListener('click', function () { locate(box); });
    (addr.closest('.es-input-column') || group).appendChild(box);
  }

  // the page is watched only for the popup appearing; style changes are watched inside the popup and its button only
  const inner = new MutationObserver(function (list) {
    list.forEach(function (m) { clean(m.target); });
    const modal = document.getElementById('easysell-modal'); if (modal) addLocate(modal);
  });
  const watched = new WeakSet();
  function hook() {
    ['easysell-modal', 'es-popup-button', 'es-sticky'].forEach(function (id) {
      const el = document.getElementById(id);
      if (!el || watched.has(el)) { if (el) clean(el); return; }
      watched.add(el); clean(el);
      if (id === 'easysell-modal') addLocate(el);
      inner.observe(el, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
    });
  }
  const outer = new MutationObserver(hook);
  function start() { hook(); outer.observe(document.body, { childList: true, subtree: true }); }   // cheap: two id lookups per change
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
